import React, {useEffect} from "react";
import {useNavigate} from "react-router";
import {useCore} from "../hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {Btn} from "./Btn.tsx";

export const CheckoutPreviewInHeader: React.FC = () => {
  const navigate = useNavigate()
  const { checkouts, selectedCheckoutId } = useCore()

  useEffect(() => {
    // switching between companies, checkout check:
    if (checkouts?.length && selectedCheckoutId) {
      if (checkouts?.find(c => c.id === selectedCheckoutId)?.name) {
        // console.log('all good, checkout exists')
      } else {
        // console.log('nope, checkout does not exists in this company')
        navigate('/checkout-select')
      }
    }
  }, [checkouts, selectedCheckoutId])

  return (
    <div className="flex flex-row">
      <div onClick={() => navigate('/checkout-select')} className="cursor-pointer border border-base-300 rounded-md p-2 2xl:px-4 2xl:ml-2 2xl:ml-4">
        <div className="flex flex-row items-center text-primary">
          <FontAwesomeIcon icon={['far', 'cash-register']} className="text-primary mr-2" />
          <span className="font-semibold text-md">{checkouts?.find(c => c.id === selectedCheckoutId)?.name}</span>
          <FontAwesomeIcon icon={['far', 'chevron-down']} className="text-primary ml-4" />
        </div>
      </div>
      <Btn className="btn-primary btn-soft ml-1 2xl:ml-2 max-xl:btn-sm" children={'Uzavřít pokladnu'} icon={'fa-download'} onClick={() => navigate(`/checkout-close/${selectedCheckoutId}`)} />
    </div>
  )
}
